<template>
    <div class="cardEventContainer">
      <md-table class="cardEvents" v-model="events" md-card md-fixed-header>
           <md-table-row slot="md-table-row" slot-scope="{ item }" :md-disabled="item.event.includes('Created')">
             <md-table-cell class="cellEventIcon">
                <md-button class="md-icon-button md-accent eventButton" v-if="events.indexOf(item) === 0" @click="showDeleteDialog(item)">
                    <md-icon class="eventButtonIcon">remove_circle</md-icon>
                </md-button>
             </md-table-cell>
             <md-table-cell md-label="Time" class="md-display-1 cellEventTime">
               {{item.time}}
              </md-table-cell>
             <md-table-cell md-label="Event" class="md-display-1 cellEventName">{{item.event}}</md-table-cell>
           </md-table-row>
      </md-table>
      <md-dialog-confirm :md-active.sync="showDeleteEventsConfirm" md-title="Delete Event?"
      :md-content="'The following event will be deleted: <br> ' + itemToDelete.time + ' - ' + itemToDelete.event + '<br> Are you sure you want to continue?'"
      md-confirm-text="Yes" md-cancel-text="No" @md-confirm="deleteEvent(itemToDelete.id)"/>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { gameEventTypes } from '../constants.js'
import { Duration, DateTime } from 'luxon'

var lastEventState = 0
var lastEventStateTime = Duration.fromMillis(0)
var playTime = Duration.fromMillis(0)

export default {
  name: 'GameEvents',
  data: function () {
    return {
      showDeleteEventsConfirm: false,
      itemToDelete: {}
    }
  },
  computed: {
    ...mapState(['gameTimerPlayers', 'activeGameId', 'activeSeasonId', 'gameTimer', 'loading', 'gameTimerEvents', 'gameTimerGame']),
    ...mapGetters(['gameTimerPlayerById', 'gameTimerGameBroadcast']),
    events: function () {
      let rows = []
      playTime = Duration.fromMillis(0)
      for (let index = 0; index < this.gameTimerEvents.length; index++) {
        const event = this.gameTimerEvents[index]
        let newRow = {}
        newRow.time = this.eventTime(event.e, event.t)
        newRow.event = this.eventName(event.e, event.d)
        newRow.id = event.id
        rows.unshift(newRow)
      }
      return rows
    }
  },
  methods: {
    ...mapActions(['displayError', 'displayMessage']),
    eventName: function (eventType, eventData) {
      switch (eventType) {
        case gameEventTypes.created:
          return 'Game Created'
        case gameEventTypes.play:
          return 'Start/Resume'
        case gameEventTypes.pause:
          return 'Pause'
        case gameEventTypes.next:
          return 'Next Level and Pause'
        case gameEventTypes.previous:
          return 'Previous Level/Reset Current Level and Pause'
        case gameEventTypes.topup:
          return this.gameTimerPlayerById(eventData.i1).n + ' Topped Up'
        case gameEventTypes.knockout:
          let player1 = this.gameTimerPlayerById(eventData.i1).n
          let player2 = this.gameTimerPlayerById(eventData.i2).n
          let rebuy = eventData.r
          let name = player1 + ' was knocked out by ' + player2
          if (rebuy) { name += ' and rebought' }
          return name
        case gameEventTypes.finished:
          return 'Game Finished'
        default:
          return ''
      }
    },
    eventTime: function (eventTy, eventTi) {
      let eventType = eventTy
      let eventTime = DateTime.fromISO(eventTi)
      let currentPlayTime = Duration.fromMillis(0)
      switch (eventType) {
        case gameEventTypes.created:
          lastEventState = eventType
          lastEventStateTime = eventTime
          playTime = Duration.fromMillis(0)
          currentPlayTime = playTime
          break
        case gameEventTypes.pause:
          if (lastEventState === gameEventTypes.play) {
            playTime = playTime.plus(eventTime.diff(lastEventStateTime))
          }
          lastEventState = eventType
          lastEventStateTime = eventTime
          currentPlayTime = playTime
          break
        case gameEventTypes.topup:
        case gameEventTypes.knockout:
          if (lastEventState === gameEventTypes.play) {
            currentPlayTime = playTime.plus(eventTime.diff(lastEventStateTime))
          } else {
            currentPlayTime = playTime
          }
          break
        case gameEventTypes.finished:
          if (lastEventState === gameEventTypes.play) {
            playTime = playTime.plus(eventTime.diff(lastEventStateTime))
          }
          lastEventState = eventType
          lastEventStateTime = eventTime
          currentPlayTime = playTime
          break
        case gameEventTypes.next:
        case gameEventTypes.previous:
          let timePassedDuration = Duration.fromMillis(0)
          let resetDuration = Duration.fromMillis(0)
          let durationSinceEvent = eventTime.diff(lastEventStateTime)
          let index = 0
          let levels = this.gameTimerGame.schedule.levels
          let previousLevel = false
          switch (lastEventState) {
            case gameEventTypes.created:
              break
            case gameEventTypes.play:
              timePassedDuration = durationSinceEvent.plus(playTime)
              break
            case gameEventTypes.pause:
              timePassedDuration = playTime
              break
            case gameEventTypes.previous:
            case gameEventTypes.next:
              timePassedDuration = playTime
              previousLevel = true
              break
            default:
              break
          }

          while (index < levels.length && timePassedDuration.as('minutes') >= levels[index].m) {
            timePassedDuration = timePassedDuration.minus(Duration.fromObject({minutes: levels[index].m}))
            resetDuration = resetDuration.plus(Duration.fromObject({minutes: levels[index].m}))
            index += 1
          }
          if (eventType === gameEventTypes.previous) {
            if (previousLevel || index === levels.length) {
              if (index > 0) {
                playTime = resetDuration.minus(Duration.fromObject({minutes: levels[index - 1].m}))
              } else {
                playTime = resetDuration
              }
            } else {
              playTime = resetDuration
            }
          } else {
            if (index === levels.length) {
              playTime = resetDuration
            } else {
              playTime = resetDuration.plus(Duration.fromObject({minutes: levels[index].m}))
            }
          }
          lastEventState = eventType
          lastEventStateTime = eventTime
          currentPlayTime = playTime
          break
        default:
          if (lastEventState === gameEventTypes.play) {
            playTime = playTime.plus(eventTime.diff(lastEventStateTime))
          }
          lastEventState = eventType
          lastEventStateTime = eventTime
          currentPlayTime = playTime
          break
      }
      return currentPlayTime.toFormat('hh:mm:ss')
    },
    showDeleteDialog: function (item) {
      this.itemToDelete = item
      this.showDeleteEventsConfirm = true
    },
    deleteEvent: function (eventId) {
      let deletePayload = {seasonId: this.activeSeasonId, gameId: this.activeGameId, eventId: eventId, broadcast: this.gameTimerGameBroadcast}
      this.$store.dispatch('deleteGameEvent', deletePayload).then(() => {
        this.displayMessage('Event deleted successfully')
      }).catch((err) => {
        this.displayError(err.message)
      })
    }
  }
}
</script>

<style lang="scss">
   .cardEvents {
    margin: 0px;
    box-shadow: none;
    text-align: left;
  }
  .cardEvents .md-table-cell {
    height: initial;
  }
  .cardEvents .md-table-head-label {
    padding: 0.31vw 0.26vw 0.31vw 0.26vw !important;
  }
  .cellEventIcon {
    width: 1.5vw;
  }
  .cellEventIcon .md-table-cell-container {
    font-size: 1.25vw;
    padding: 0.31vw 0.26vw 0.31vw 0.26vw !important;
  }
  .cellEventTime .md-table-cell-container {
    font-size: 1.25vw;
    padding: 0.31vw 0.26vw 0.31vw 0.26vw !important;
  }
  .cellEventTime {
    width: 2vw;
  }
  .cellEventName .md-table-cell-container {
    font-size: 1.15vw;
    padding: 0.31vw 0.26vw 0.31vw 0.26vw !important;
  }
  .cellEventTime {
    white-space: nowrap;
  }
  .eventButton {
    width: 1.25vw;
    height: 1.25vw;
    margin: 0px;
    min-width: 0px;
  }

  .eventButtonIcon {
    font-size: 1.25vw !important;
    min-width: 0px;
  }
  .md-table .md-table-content {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
  }
</style>
